<template>
  <div :class="`pdf-container ${pdfContainerClass}`"></div>
</template>

<script>
  import PSPDFKit from "pspdfkit";
  import auth from '../authConfig.js';


  export default {
    name: 'PSPDFKit',
    props: {
      applicationNumber: Number,
      isShowing: Boolean,
      pdfContainerClass: String,
      pdfFile: {
        type: String,
        required: true,
      },
      attachments: Array,
      selectedAttchement: Object,
      document: Object,
      showEditorButton: Boolean,
      showAssignButton: Boolean,
      showAcceptRejectButton: Boolean,
      showPrevNext: Boolean,
      showJunkButton: Boolean,
      fromConsumer: Boolean,
      disablePrev: Boolean,
      disableNext: Boolean,
      currentTaskStatus: String
    },
    emits: ['fileSplit', 'loaded','removeAttchment', 'fhaaddendum1', 'fhacommitment1', 'fhatransmittal1', 'onassigndocument', 
            'onjunkdocument', 'fhaaddendum2', 'fhacommitment2', 'fhatransmittal2', 'fhaaddendum3', 'fhacommitment3', 'fhatransmittal3', 
            'onaccepttask', 'onrejecttask', 'onviewnext', 'onviewprev'],
    data() {
      return{
        fhaDocsBase64: [
          { fileName: 'HUD/V.A. Addendum to Uniform Residential Loan Application', emits: 'fhaaddendum1', applicationNumber: 1 },
          { fileName: 'HUD-92800.5B Appraised Value', emits: 'fhacommitment1', applicationNumber: 1 },
          { fileName: 'FHA Loan Transmittal', emits: 'fhatransmittal1', applicationNumber: 1 },
          { fileName: 'HUD/V.A. Addendum to Uniform Residential Loan Application', emits: 'fhaaddendum2', applicationNumber: 2 },
          { fileName: 'HUD-92800.5B Appraised Value', emits: 'fhacommitment2', applicationNumber: 2 },
          { fileName: 'FHA Loan Transmittal', emits: 'fhatransmittal2', applicationNumber: 2 },
          { fileName: 'HUD/V.A. Addendum to Uniform Residential Loan Application', emits: 'fhaaddendum3', applicationNumber: 3 },
          { fileName: 'HUD-92800.5B Appraised Value', emits: 'fhacommitment3', applicationNumber: 3 },
          { fileName: 'FHA Loan Transmittal', emits: 'fhatransmittal3', applicationNumber: 3 }
        ],
        fhaDocDisplay: '',
        fileToSplit: [],
        fromConsumerEditItemTypes: ['rotate-left', 'rotate-right', 'spacer', 'undo', 'redo', 'select-all', 'select-none', 'zoom-out', 'zoom-in'],
        pdfInstance: {},
        signatureImage: null,
        signatureImageBlob: null,
        signatureWidth: null,
        userName: '',
        lastSearchState: {
          term: null,
          results: null,
          currentIndex: 0
        }
      }
    },
   async mounted() {
    await this.initialize();
    },
    watch: {
      isShowing(val) {
        if (val) {
          this.initialize();
        }
      },
    //   pdfFile(val, old) {
    //     if (val && val !== old) {
    //         console.log('new pdffile', val, old)
    //       this.initialize();
    //     }
    //   },
    },
    methods: {
      async initialize() {
        let tokenResponse = await auth.acquireTokenResponse();
      
        this.userName = tokenResponse.account.name;

        this.loadPSPDFKit().then((instance) => {
          if (this.pdfContainerClass && this.pdfContainerClass.includes('fha-docs-viewer')) {
            this.generateFHASignatures(instance);
          }
          
        this.$emit("loaded", instance);
        const typesToFilter = [
          "sidebar-thumbnails",
          "pager",
          "pan",
          "zoom-out",
          "zoom-in",
          "zoom-mode",
          "spacer",
          "search",
          "debug"
        ];

        const editButton = {
          type: "custom",
          id: "editDocButton",
          title: "Edit File",
          className:'edit-doc-button',
          onPress: (event) => {
            instance.setViewState(viewState =>
              viewState.set(
                "interactionMode",
                PSPDFKit.InteractionMode.DOCUMENT_EDITOR
              )
            );
          }
        };

        const assignButton = {
          type: 'custom',
          id: 'assignDocButton',
          title: 'Assign/Rename File',
          className: 'assign-doc-button',
          onPress: (event) => {
            this.$emit('onassigndocument');
          }
        }

        const junkButton = {
            type: 'custom',
            id: 'junkDocButton',
            title: 'Move to Junk Folder',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M177.7 16l92.5 0c8.3 0 16 4.3 20.4 11.3l23 36.7L134.4 64l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L115.6 64 8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8l432 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L332.4 64 304.2 18.8C296.9 7.1 284.1 0 270.3 0L177.7 0c-13.8 0-26.6 7.1-33.9 18.8zM48 119.3c-.4-4.4-4.2-7.7-8.6-7.3s-7.7 4.2-7.3 8.6l28.3 340c2.4 29 26.7 51.4 55.8 51.4l215.7 0c29.1 0 53.4-22.3 55.8-51.4l28.3-340c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3l-28.3 340C370 480.1 352.6 496 331.8 496l-215.7 0c-20.8 0-38.1-15.9-39.9-36.7L48 119.3z"/></svg>',
            className: 'junk-doc-button',
            onPress: (event) => {
                this.$emit('onjunkdocument');
            }
        }

        const prevButton = {
            type: 'custom',
            id: 'prevButton',
            title: 'Previous Document',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320zm48 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM80 256c0-7.2 2.9-14.2 8-19.3L187.7 137c5.7-5.7 13.5-9 21.7-9c16.9 0 30.6 13.7 30.6 30.6l0 49.4 88 0c22.1 0 40 17.9 40 40l0 16c0 22.1-17.9 40-40 40l-88 0 0 49.4c0 16.9-13.7 30.6-30.6 30.6c-8.1 0-15.9-3.2-21.7-9L88 275.3c-5.1-5.1-8-12.1-8-19.3zm19.3 8L199 363.7c2.7 2.7 6.5 4.3 10.3 4.3c8.1 0 14.6-6.6 14.6-14.6l0-57.4c0-4.4 3.6-8 8-8l96 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24l-96 0c-4.4 0-8-3.6-8-8l0-57.4c0-8.1-6.5-14.6-14.6-14.6c-3.9 0-7.6 1.5-10.3 4.3L99.3 248c-2.1 2.1-3.3 5-3.3 8s1.2 5.9 3.3 8z"/></svg>',
            className: 'prev-button',
            disabled: this.disablePrev,
            onPress: (event) => {
                this.$emit('onviewprev')
            }
       }

       const nextButton = {
            type: 'custom',
            id: 'nextButton',
            title: 'Next Document',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M432 96c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM368 256c0 7.2-2.9 14.2-8 19.3L260.3 375c-5.7 5.7-13.5 9-21.7 9c-16.9 0-30.6-13.7-30.6-30.6l0-49.4-88 0c-22.1 0-40-17.9-40-40l0-16c0-22.1 17.9-40 40-40l88 0 0-49.4c0-16.9 13.7-30.6 30.6-30.6c8.1 0 15.9 3.2 21.7 9L360 236.7c5.1 5.1 8 12.1 8 19.3zm-19.3-8L249 148.3c-2.7-2.7-6.5-4.3-10.3-4.3c-8.1 0-14.6 6.5-14.6 14.6l0 57.4c0 4.4-3.6 8-8 8l-96 0c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24l96 0c4.4 0 8 3.6 8 8l0 57.4c0 8.1 6.5 14.6 14.6 14.6c3.9 0 7.6-1.5 10.3-4.3L348.7 264c2.1-2.1 3.3-5 3.3-8s-1.2-5.9-3.3-8z"/></svg>',
            className: 'next-button',
            disabled: this.disableNext,
            onPress: (event) => {
                this.$emit('onviewnext')
            }
       }

        const acceptTaskButton = {
          type: 'custom',
          id: 'acceptTaskButton',
          title: 'Accept Task',
          className: 'accept-task-button',
          onPress: (event) => {
            this.$emit('onaccepttask');
          }
        }

        const rejectTaskButton = {
          type: 'custom',
          id: 'rejectTaskButton',
          title: 'Reject Task',
          className: 'reject-task-button',
          onPress: (event) => {
            this.$emit('onrejecttask');
          }
        }

        const downloadButton = {
          type: 'custom',
          id: 'downloadDocButton',
          title: 'Download',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M365.7 213.7l-136 136c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 324.7 216 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 316.7L354.3 202.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM16 328l0 96c0 39.8 32.2 72 72 72l272 0c39.8 0 72-32.2 72-72l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8l0 96c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8z"/></svg>',
          className: 'download-doc-button',
          onPress: (event) => {
            instance.exportPDF().then((buffer) => {
              const blob = new Blob([buffer], { type: "application/pdf" });
              const fileName = this.selectedAttchement?.title ?? 'document.pdf';
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = objectUrl;
                a.style = "display: none";
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
              }
            });
          }
        }

        const items = instance.toolbarItems;
        instance.setToolbarItems(items.filter(item => typesToFilter.includes(item.type)));
        this.pdfInstance = instance;
     
        let self = this;
        // Create a div element
        var divElement = document.createElement('div');
        divElement.style.marginTop = '10px';
        divElement.style.marginLeft = '10px';

        // Set the text content
        divElement.innerHTML = ' <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width:20px;margin-right:5px"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0-47.4-25.7-88.7-64-110.9V109.3l-41.4 41.4z"/><path class="fa-primary" d="M9.4 310.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 224 256c70.7 0 128 57.3 128 128c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64l-114.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96z"/></svg><span style="margin-top:-3px">Split Documents</span>';
        const splitButton = {
          type: "custom",
          id: "my-split-button",
          node: divElement,
          className: 'svg-div',
          selected: false,
          disabled:false,
          onPress: (event, { setOperations, getSelectedPageIndexes }) => {
            if (getSelectedPageIndexes().length === 0) {
              return;
            }

            const operations = [
              {
                type: "keepPages",
                pageIndexes: getSelectedPageIndexes(),
              }
            ];
            self.pdfInstance.exportPDFWithOperations(operations).then(function (buffer) {
              self.fileToSplit = { file: self.arrayBufferToBase64(buffer), title: self.attachments.find(x => x.id === self.selectedAttchement.id)?.title, bucketTitle: self.document?.title, bucketId: self.document?.id }
              self.$emit('fileSplit', self.fileToSplit);             
            });
          }
        };

        instance.addEventListener("document.change", (event) => {
          instance.exportPDF().then(function (buffer) {
              self.fileToSplit = { file: self.arrayBufferToBase64(buffer), title: self.attachments.find(x => x.id === self.selectedAttchement.id)?.title, bucketTitle: self.document?.title, bucketId: self.document?.id }
              self.$emit('fileSplit', self.fileToSplit);
              self.$emit('removeAttchment', self.selectedAttchement.id)
          });
        });
        
        const separator = items.find(item => item.type === "spacer");

        instance.setDocumentEditorToolbarItems((items) => {
          items.splice(4, 1, splitButton);
          items.splice(5, 1, separator);
          
          return items;
        });

        if (this.showEditorButton) {
          instance.setToolbarItems((items) => {
            let spacerIndex = items.findIndex(item => item.type === 'spacer');

            if (spacerIndex > -1) {
              items.splice(spacerIndex, 0, editButton);
            }

            return items;
          });
        }

        if (this.showAssignButton) {
          instance.setToolbarItems((items) => {
            let spacerIndex = items.findIndex(item => item.type === 'spacer');

            if (spacerIndex > -1) {
              items.splice(spacerIndex, 0, assignButton);
            }

            return items;
          });
        }

        if (this.showJunkButton) {
            instance.setToolbarItems((items) => {
                let spacerIndex = items.findIndex(item => item.type === 'spacer');

                if (spacerIndex > -1) {
                    items.splice(spacerIndex + 1, 0, junkButton);
                }

                return items;
            });
        }

        if (this.showPrevNext) {
            instance.setToolbarItems((items) => {
                let spacerIndex = items.findIndex(item => item.type === 'spacer');

                if (spacerIndex > -1) {
                    items.splice(spacerIndex, 0, prevButton, nextButton);
                }

                return items;
            });
        }

        if (this.fromConsumer && this.showAcceptRejectButton) {
          if (this.currentTaskStatus === 'Pending' || this.currentTaskStatus === 'Requested') {
            instance.setToolbarItems((items => {
                let spacerIndex = items.findIndex(item => item.type === 'spacer');

                if (spacerIndex > -1) {
                    items.splice(spacerIndex, 0, acceptTaskButton, rejectTaskButton);
                }

                return items;
            }))
          }

          if (this.currentTaskStatus === 'Rejected') {
            instance.setToolbarItems((items => {
                let spacerIndex = items.findIndex(item => item.type === 'spacer');

                if (spacerIndex > -1) {
                    items.splice(spacerIndex, 0, acceptTaskButton);
                }

                return items;
            }))
          }
        }

        instance.setToolbarItems((items) => {
          items.push(downloadButton);

          return items;
        })
      });
      },
      arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      },
      base64ToBlob(base64, type='image/png') {
          const binStr = atob(base64.split(',')[1]);
          const len = binStr.length;
          const arr = new Uint8Array(len);

          for (let i = 0; i< len; i++) {
              arr[i] = binStr.charCodeAt(i);
          }

          return new Blob([arr], {type: type});
      },
      async generateFHASignatures(instance) {
        if (!instance) return;

        if (!this.signatureImage || !this.signatureImageBlob) {
          this.generateSignatureImage();
          this.signatureImageBlob = this.base64ToBlob(this.signatureImage);
        }

        const imageAttachmentId = await instance.createAttachment(this.signatureImageBlob);

        let annotations = [];

        if (this.selectedAttchement.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application') {
          annotations.push(new PSPDFKit.Annotations.ImageAnnotation({
            pageIndex: 2,
            isSignature: true,
            contentType: 'image/png',
            imageAttachmentId,
            description: 'User signature',
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: 215,
              top: 546,
              width: 250,
              height: 100,
            }),
          }));

          annotations.push(new PSPDFKit.Annotations.ImageAnnotation({
            pageIndex: 2,
            isSignature: true,
            contentType: 'image/png',
            imageAttachmentId,
            description: 'User signature',
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: 210,
              top: 208,
              width: 250,
              height: 100,
            }),
          }));
        }

        if (this.selectedAttchement.docName === 'HUD-92800.5B Appraised Value') {
          annotations.push(new PSPDFKit.Annotations.ImageAnnotation({
            pageIndex: 0,
            isSignature: true,
            contentType: 'image/png',
            imageAttachmentId,
            description: 'User signature',
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: 110,
              top: 268,
              width: 250,
              height: 100,
            }),
          }));

          annotations.push(new PSPDFKit.Annotations.ImageAnnotation({
            pageIndex: 2,
            isSignature: true,
            contentType: 'image/png',
            imageAttachmentId,
            description: 'User signature',
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: 110,
              top: 268,
              width: 250,
              height: 100,
            }),
          }));

          annotations.push(new PSPDFKit.Annotations.ImageAnnotation({
            pageIndex: 4,
            isSignature: true,
            contentType: 'image/png',
            imageAttachmentId,
            description: 'User signature',
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: 110,
              top: 255,
              width: 250,
              height: 100,
            }),
          }));
        }

        if (this.selectedAttchement.docName === 'FHA Loan Transmittal') {
          annotations.push(new PSPDFKit.Annotations.ImageAnnotation({
            pageIndex: 0,
            isSignature: true,
            contentType: 'image/png',
            imageAttachmentId,
            description: 'User signature',
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: 235,
              top: 605,
              width: 250,
              height: 100,
            }),
          }));
        }

        annotations.forEach(async (annotation) => {
          await instance.create(annotation);
        });

        await instance.save();

        instance.exportPDF()
          .then((buffer) => {
            let fhaBase64 = this.arrayBufferToBase64(buffer);
            this.$emit(this.fhaDocsBase64.find(doc => doc.fileName === this.selectedAttchement.docName && doc.applicationNumber === this.applicationNumber)?.emits, fhaBase64);
          });

      },
      generateSignatureImage() {
          const signatureText = this.userName;
          const signatureImage = this.createSignatureImage(signatureText);
          this.signatureImage = signatureImage;
      },
      createSignatureImage(signatureText) {
          const canvas = document.createElement('canvas');
          const ratio = window.devicePixelRatio;
          const ctx = canvas.getContext('2d');
          let scale = 2;
          ctx.font = '30px "Segoe Script"';
          canvas.height = canvas.height * ratio * scale;
          canvas.width = canvas.width * ratio * scale;
          ctx.fillStyle = '#000000';
          ctx.font = '30px "Segoe Script"';
          ctx.textAlign = 'start';
          ctx.textBaseline = 'middle';
          ctx.fillText(signatureText, 0, canvas.height / 2);
          return canvas.toDataURL('image/png');
      },
      async loadPSPDFKit() {  
        var defaultToolbarItems = PSPDFKit.defaultDocumentEditorToolbarItems;
     
        var defaultEditorFooterIcons = PSPDFKit.defaultDocumentEditorFooterItems;
     
        defaultToolbarItems = defaultToolbarItems.filter((item) => item.type !== "import-document" && item.type !== "add" && item.type !== "extract-pages" && item.type !== "import-document" && item.type !== "add" && item.type !== "move" && item.type !== "move-right" && item.type !== "move-left" )

        defaultEditorFooterIcons = defaultEditorFooterIcons.filter((item) => item.type !== "save-as" )      

        PSPDFKit.unload(`.${this.pdfContainerClass}`);

        return PSPDFKit.load({
          initialViewState: new PSPDFKit.ViewState({
            sidebarMode: PSPDFKit.SidebarMode.THUMBNAILS
          }),
          autoSaveMode: PSPDFKit.AutoSaveMode.DISABLED,
          licenseKey: process.env.VUE_APP_PSPDFKEY,
          documentEditorToolbarItems: defaultToolbarItems,
          documentEditorFooterItems: defaultEditorFooterIcons,
          document: this.pdfFile,
          container: `.${this.pdfContainerClass}`,
          styleSheets: [
                  "../my-pspdfkit.css" // or local CSS file
          ]
        })
      },
      async searchAndHighlight(searchTerm) {
        
        if (!this.pdfInstance || !searchTerm.trim()) {
          console.warn('PDF instance not available or empty search term');
          return false;
        }

        try {
          const cleanSearchTerm = searchTerm.trim();
          
          // Check if this is the same search term (for cycling)
          const isRepeatSearch = this.lastSearchState.term === cleanSearchTerm;
          
          if (isRepeatSearch && this.lastSearchState.results && this.lastSearchState.results.size > 1) {
            // Cycle to next result
            this.lastSearchState.currentIndex = (this.lastSearchState.currentIndex + 1) % this.lastSearchState.results.size;
            const targetResult = this.lastSearchState.results.get(this.lastSearchState.currentIndex);
                        
            // Navigate to the result page
            await this.pdfInstance.setViewState(viewState =>
              viewState.set('currentPageIndex', targetResult.pageIndex)
            );
            
            // Start UI search to highlight
            if (typeof this.pdfInstance.startUISearch === 'function') {
              await this.pdfInstance.startUISearch(cleanSearchTerm);
            }
            
            // Try to zoom and center on the result
            await this.zoomToSearchResult(targetResult);
            
            return true;
          }
          
          // Clear any existing search for new searches
          if (typeof this.pdfInstance.clearSearch === 'function') {
            await this.pdfInstance.clearSearch();
          }
          
          // Perform the search
          const results = await this.pdfInstance.search(cleanSearchTerm);
          
          if (results && results.size > 0) {
            // Store search state for potential cycling
            this.lastSearchState = {
              term: cleanSearchTerm,
              results: results,
              currentIndex: 0
            };
            
            const firstResult = results.get(0);
            
            // Navigate to the first result page
            await this.pdfInstance.setViewState(viewState =>
              viewState.set('currentPageIndex', firstResult.pageIndex)
            );
            
            // Start UI search to highlight  
            if (typeof this.pdfInstance.startUISearch === 'function') {
              await this.pdfInstance.startUISearch(cleanSearchTerm);
            }
            
            // Try to zoom and center on the result
            await this.zoomToSearchResult(firstResult);
            
            return true;
          }
          
          return false;
        } catch (error) {
          console.error('Search failed:', error);
          return false;
        }
      },
      async zoomToSearchResult(result) {
        try {
          
          // Try multiple ways to get rects from the result
          let rects = null;
          let rect = null;
          
          // Method 1: result.get('rects') - Immutable.js way
          if (result.get && typeof result.get === 'function') {
            rects = result.get('rects');
          }
          
          // Method 2: If result has _values (Immutable.js structure), try to access it
          if (!rects && result._values) {
            
            // If _values has a _tail.array, that's likely where the actual data is
            if (result._values._tail && result._values._tail.array) {
              const tailArray = result._values._tail.array;
              
              // Based on the structure, it looks like:
              // [0] = pageIndex, [1] = searchText, [2] = left?, [3] = top?, [4] = rects collection, [5] = boolean
              if (tailArray.length >= 5) {
                
                // Try to get rects from index 4
                const rectsCollection = tailArray[4];
                if (rectsCollection && typeof rectsCollection === 'object') {

                  // Try to get rects using Immutable.js methods
                  if (rectsCollection.get && typeof rectsCollection.get === 'function') {
                    const firstRect = rectsCollection.get(0);
                    
                    if (firstRect && firstRect._values) {
                      
                      // Check if the rect _values has a _tail.array
                      if (firstRect._values._tail && firstRect._values._tail.array) {
                        const rectArray = firstRect._values._tail.array;
                        
                        // The rect array likely contains [left, top, width, height] or similar
                        if (rectArray.length >= 4) {
                          rect = {
                            left: rectArray[0],
                            top: rectArray[1], 
                            width: rectArray[2],
                            height: rectArray[3]
                          };
                        }
                      }
                      
                      // Also try to access rect properties directly using Immutable.js get
                      if (!rect && firstRect._values.get && typeof firstRect._values.get === 'function') {
                        const left = firstRect._values.get('left') ?? firstRect._values.get(0);
                        const top = firstRect._values.get('top') ?? firstRect._values.get(1);
                        const width = firstRect._values.get('width') ?? firstRect._values.get(2);
                        const height = firstRect._values.get('height') ?? firstRect._values.get(3);
                        
                        
                        if (typeof left === 'number' && typeof top === 'number') {
                          rect = {
                            left: left,
                            top: top,
                            width: width || 100,
                            height: height || 20
                          };
                        }
                      }
                    }
                    
                    if (firstRect && !rect) {
                      rects = rectsCollection;
                    }
                  }
                  
                  // Try to access _tail.array of the rects collection
                  if (!rects && rectsCollection._tail && rectsCollection._tail.array) {
                    rects = rectsCollection;
                  }
                }
                
                // If we can't find proper rects, try to construct a rect from the coordinates
                if (!rects && typeof tailArray[2] === 'number' && typeof tailArray[3] === 'number') {
                  rect = {
                    left: tailArray[2],
                    top: tailArray[3],
                    width: 100, // Default width
                    height: 20  // Default height
                  };
                }
              }
            }
            
            // Try to get rects from the _values using Immutable.js methods
            if (result._values.get && typeof result._values.get === 'function') {
              rects = result._values.get('rects');
              
              // Try other common keys
              const pageIndex = result._values.get('pageIndex');
              const searchTerm = result._values.get('searchTerm');
              const boundingBox = result._values.get('boundingBox');
            }
            
            // Also try direct access
            if (!rects && result._values.rects) {
              rects = result._values.rects;
            }
          }
          
          // Method 3: result.rects
          if (!rects && result.rects) {
            rects = result.rects;
          }
          
          // Method 4: Check if result itself has rect properties
          if (!rects && (result.left !== undefined || result.x !== undefined)) {
            rect = result;
          }
          
          // Extract first rect
          if (!rect && rects) {
            if (rects.get && typeof rects.get === 'function' && rects.size > 0) {
              rect = rects.get(0);
            } else if (rects.length > 0) {
              rect = rects[0];
            } else if (rects.size > 0) {
              // Try to iterate through the rects
              for (let r of rects) {
                rect = r;
                break;
              }
            }
          }
          
          if (rect) {
            
            // Add delay to ensure page navigation and search highlighting are complete
            setTimeout(async () => {
              try {
                // Get rect coordinates (handle different property names)
                const left = rect.left ?? rect.x ?? 0;
                const top = rect.top ?? rect.y ?? 0;
                const width = rect.width ?? rect.w ?? 100;
                const height = rect.height ?? rect.h ?? 50;
                
                
                // Method 1: Try jumpAndZoomToRect first
                
                if (typeof this.pdfInstance.jumpAndZoomToRect === 'function') {
                  
                  // Smaller rect = more zoom, larger rect = less zoom
                  const expandedRect = new PSPDFKit.Geometry.Rect({
                    left: Math.max(0, left - 120),
                    top: Math.max(0, top - 120), 
                    width: width + 240,
                    height: height + 240
                  });
                  
                  await this.pdfInstance.jumpAndZoomToRect(result.pageIndex, expandedRect);
                  return;
                }
                
                // Method 2: Try transformViewState
                if (typeof this.pdfInstance.transformViewState === 'function') {
                  
                  await this.pdfInstance.transformViewState(viewState => {
                    const centerX = left + (width / 2);
                    const centerY = top + (height / 2);
                    
                    return viewState
                      .set('zoom', 3.0)
                      .set('scrollLeft', Math.max(0, centerX - 300))
                      .set('scrollTop', Math.max(0, centerY - 200));
                  });
                  
                  return;
                }
                
                // Method 3: Manual setViewState
                const currentViewState = this.pdfInstance.viewState;
                const centerX = left + (width / 2);
                const centerY = top + (height / 2);
                
                
                const newViewState = currentViewState
                  .set('zoom', 3.0)
                  .set('scrollLeft', Math.max(0, centerX - 300))
                  .set('scrollTop', Math.max(0, centerY - 200));
                
                await this.pdfInstance.setViewState(newViewState);
                
              } catch (error) {
                console.error('❌ All zoom methods failed:', error);
              }
            }, 300);
          } else {
          }
        } catch (error) {
          console.error('Error in zoomToSearchResult:', error);
        }
      }
    },
    beforeUnmount() {
      PSPDFKit.unload(`.${this.pdfContainerClass}`);
    },
  };
</script>

<style >
  .pdf-container {
    height: 100%;
    width: 100%;
  }
  

</style>

